// src/components/Footer.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Footer.css';
import LegalModal from './LegalModal';

const Footer = () => {
  const [legalModal, setLegalModal] = useState({ open: false, type: null });
  return (
    <footer className="relative bg-gradient-to-br from-brand-dark via-slate-900 to-gray-900 text-white overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-20" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Ccircle cx='30' cy='30' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }}></div>
      
      <motion.div className="relative z-10 max-w-7xl mx-auto px-6 pt-16 pb-0"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <div className="footer-grid">
          <div className="footer-col footer-brand">
            <h2 className="footer-logo">Radha IT</h2>
            <p className="muted">Trusted partner for IT, cloud, AI, security, networking and AV solutions.</p>

            <div className="contact-list">
              <a href="mailto:info@radhait.ca" className="contact-link" aria-label="Email Radha IT">info@radhait.ca</a>
              <a href="tel:+12894088343" className="contact-link" aria-label="Call Radha IT">+1 (289) 408-8343</a>
            </div>
          </div>

          <nav className="footer-col" aria-label="Footer navigation">
            <h3 className="col-title">Services</h3>
            <ul className="footer-links">
              <li><Link to="/services#web-development">Web Development</Link></li>
              <li><Link to="/services#cloud">Cloud & Hosting</Link></li>
              <li><Link to="/services#ai">AI & Automation</Link></li>
              <li><Link to="/services#security">Security & Networking</Link></li>
              <li><Link to="/services#av-solutions">AV Solutions</Link></li>
            </ul>
          </nav>

          <div className="footer-col">
            <h3 className="col-title">Clients & Tech</h3>
            <ul className="footer-links muted-list">
              <li>WordPress</li>
              <li>React</li>
              <li>Node.js</li>
              <li>Google Cloud / AWS</li>
              <li>Cisco / Ubiquiti</li>
            </ul>
          </div>

          {/* Social links removed — no social media at this time */}
        </div>

        <div className="footer-bottom">
          <p className="muted small">© {new Date().getFullYear()} Radha IT — Empowering businesses through technology.</p>
          <div className="legal-links">
            <a href="#privacy" className="muted" onClick={(e) => { e.preventDefault(); setLegalModal({ open: true, type: 'privacy' }); }} aria-haspopup="dialog">Privacy</a>
            <a href="#terms" className="muted" onClick={(e) => { e.preventDefault(); setLegalModal({ open: true, type: 'terms' }); }} aria-haspopup="dialog">Terms</a>
          </div>
        </div>
        {legalModal.open && (
          <LegalModal open={legalModal.open} type={legalModal.type} onClose={() => setLegalModal({ open: false, type: null })} />
        )}
      </motion.div>
    </footer>
  );
};

export default Footer;
